import { useState } from "react";
import { Lock, Tv, Bot } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, formatApiError } from "@/lib/api";

export default function LoginPage({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { onLogin((await api.post("/auth/login", { email, password })).data); }
    catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen app-bg text-[#F9FAFB] flex items-center justify-center px-4">
      <form onSubmit={submit} className="panel-card w-full max-w-sm space-y-5 fade-in" data-testid="login-form">
        <div className="flex items-center gap-3">
          <div className="logo-mark"><Tv className="w-4 h-4" /><Bot className="w-4 h-4" /></div>
          <div><p className="font-heading font-bold text-lg">Bridge IPTV + IA</p><p className="text-xs text-[#6B7280]">Acesso do administrador</p></div>
        </div>
        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-mail" className="input-dark h-11" data-testid="login-email-input" required />
        <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Senha" className="input-dark h-11" data-testid="login-password-input" required />
        {error && <p className="text-sm text-red-400" data-testid="login-error">{error}</p>}
        <Button type="submit" disabled={busy} className="btn-primary h-12 w-full" data-testid="login-submit-button"><Lock className="w-4 h-4 mr-2" />{busy ? "Entrando..." : "Entrar"}</Button>
      </form>
    </div>
  );
}
